import React from 'react';
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {setSQFTSystemDeleteMessage} from "../../../../actions/sqftMenuFunctions";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";

const SqftTutorial = () => {
  const isCabinetsMode = isSFTCabinetsGroup();
  if (isCabinetsMode) {
    return null
  }

  return (
    <div className="sqft-tutorial-overlay" data-step="1">
      <div className="sqft-tutorial">
        <div className="sqft-tutorial-main">
          <p className="sqft-tutorial-main__text" id="sqft-tutorial-text"/>
          <div className="sqft-tutorial-main__buttons">
            <button className="ui-button10 ui-button10--blue" id="sqft-tutorial-close"
                    data-text="sqft.tutorial.buttonExitTutorial">
              <FormattedMessage id="sqft.tutorial.buttonExitTutorial"/>
            </button>
            <button className="ui-button10 ui-button10--secondary ui-button10--secondary--pulsating" id="sqft-tutorial-next"
                    data-text="sqft.tutorial.buttonNext">
              <FormattedMessage id="sqft.tutorial.buttonNext"/>
            </button>
          </div>
        </div>
        <span className="sqft-tutorial-step__ring sqft-tutorial-step__ring--scale"/>
        <div className="sqft-tutorial-step sqft-tutorial-step--1">
          <button className="button button--parent button--layouts" data-menu="layouts">
            <span className="button-text" data-text="sqft.tutorial.step1.buttonLayouts">
              <FormattedMessage id="sqft.tutorial.step1.buttonLayouts"/>
            </span>
          </button>
        </div>
        <div className="sqft-tutorial-step sqft-tutorial-step--2">
          <button className="button button--inner shapes-icon" data-layout="SPNI"/>
        </div>
        <div className="sqft-tutorial-step sqft-tutorial-step--3">
          <button className="button button--inner button--resize" data-set="resize" data-group="tools"
                  data-action="size">
            <span className="button-text" data-text="sqft.tutorial.step3.buttonResize">
              <FormattedMessage id="sqft.tutorial.step3.buttonResize"/>
            </span>
          </button>
        </div>
        <div className="sqft-tutorial-step sqft-tutorial-step--4">
          <button className="button button--inner button--edge" data-open="edge">
            <span className="button-text" data-text="sqft.tutorial.step4.buttonEdge">
              <FormattedMessage id="sqft.tutorial.step4.buttonEdge"/>
            </span>
          </button>
        </div>
        <div className="sqft-tutorial-step sqft-tutorial-step--5">
          <button className="info-bar-buttons__button add-to-quote">
            <span className="add-to" data-text="sqft.tutorial.step5.addToQuote">
              <FormattedMessage id="sqft.tutorial.step5.addToQuote"/>
            </span>
          </button>
          <button className="button button--parent button--add-to-quote">
            <span className="button-text" data-text="sqft.tutorial.step5.addToQuote">
              <FormattedMessage id="sqft.tutorial.step5.addToQuote"/>
            </span>
          </button>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  systemDeleteMessage: store.sqftMenuState.systemDeleteMessage
});

const mapDispatchToProps = {
  setSQFTSystemDeleteMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftTutorial);

